module.exports = __webpack_public_path__ + "static/img/18-DoE.8152788d.jpg";